'use strict';

export default class UpdatesListCtrl {
  static get UID() {
    return 'updatesListCtrl';
  }

  constructor(updateFac, $state, $stateParams, $scope) {
    Object.assign(this, { updateFac, $state, $stateParams, $scope } );

    this.videos = {}; 

    this.curPage = parseInt($stateParams.pageNum, 10) || 1;

    this.updateFac.getUpdates(0)
      .then((response) => {
        this.videos = response.data.data;
      });

    this.$scope.pager = this.pager;
  }

}



// WEBPACK FOOTER //
// ./~/site_core/src/features/updatesList/updatesListCtrl.js